import './styles.css';
import {joinWaitlist, messages} from './waitlist.ts';

const form = document.querySelector<HTMLFormElement>('#waitlist');
const status = document.querySelector<HTMLElement>('#waitlist-status');
const button = form?.querySelector<HTMLButtonElement>('button[type="submit"]');

if (form && status && button) {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    button.disabled = true;
    status.textContent = messages.sending;
    const result = await joinWaitlist(fetch, __API_URL__, {
      email: String(data.get('email') ?? ''),
      consent: data.get('consent') === 'on',
      website: String(data.get('website') ?? ''),
    });
    status.textContent = messages[result];
    status.dataset.result = result;
    if (result === 'joined') form.reset();
    button.disabled = false;
  });
}
